<template>
  <generic-modal :title="modal_title" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <!-- <label class="label">{{ $t("name") }}</label> -->
          <generic-dropdown
            :title="$t('user')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/access/user/catalog"
            name_field="username"
            value_field="user_id"
            @selected="set_user"
            ref="user_dropdown"
          />
          <!-- <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.name"
              :placeholder="$t('name')"
            />
          </div> -->
        </div>

        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.name"
              :placeholder="$t('name')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("email") }}</label>
          <div class="control">
            <input
              class="input"
              type="email"
              v-model="meta.email"
              :placeholder="$t('email')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("phone") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.phone"
              :placeholder="$t('phone')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("department") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.department"
              :placeholder="$t('department')"
            />
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">{{ $t("specialties") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              v-model="specialties_text"
              :placeholder="$t('specialties_placeholder')"
              rows="3"
            ></textarea>
          </div>
          <p class="help">{{ $t("specialties_help") }}</p>
        </div>

        <div class="field">
          <label class="label">{{ $t("working_hours") }}</label>
          <div class="columns">
            <div class="column">
              <div class="control">
                <input
                  class="input"
                  type="time"
                  v-model="meta.working_hours_start"
                  :placeholder="$t('start_time')"
                />
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input
                  class="input"
                  type="time"
                  v-model="meta.working_hours_end"
                  :placeholder="$t('end_time')"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input type="checkbox" v-model="meta.is_active" />
              {{ $t("is_active") }}
            </label>
          </div>
        </div>

        <div class="field">
          <div class="control">
            <label class="checkbox">
              <input
                type="checkbox"
                v-model="meta.can_receive_auto_assignments"
              />
              {{ $t("can_receive_auto_assignments") }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Manejo de errores -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <!-- Footer con botones -->
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon"><i class="fa fa-save"></i></span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon"><i class="fa fa-trash"></i></span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  del,
  get,
  generate_error_message_text,
  confirm_deletion_dialog,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "AgentModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      specialties_text: "",
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name || !this.meta.email;
    },
    modal_title() {
      return this.meta.uuid ? this.$t("edit_agent") : this.$t("create_agent");
    },
  },
  methods: {
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },

    show_modal(uuid = null) {
      this.set_initial_state();

      if (uuid) {
        get("/helpdesk/agent", { uuid })
          .then((agent) => {
            this.meta = agent;

            // Convertir array de especialidades a texto
            if (agent.specialties && Array.isArray(agent.specialties)) {
              this.specialties_text = agent.specialties.join(", ");
            }

            if (agent.user_id) {
              this.$refs.user_dropdown.set_value(agent.user_id);
            }

            this.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      } else {
        this.$refs.generic_modal.show_modal();
      }
    },

    save() {
      const isEdit = !!this.meta.uuid;
      const method = isEdit ? post : put;
      const endpoint = "/helpdesk/agent";

      // Convertir texto de especialidades a array
      let data = { ...this.meta };
      if (this.specialties_text.trim()) {
        data.specialties = this.specialties_text
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
      } else {
        data.specialties = [];
      }

      method(endpoint, data)
        .then(() => {
          this.$emit("success");
          this.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        });
    },

    remove() {
      confirm_deletion_dialog(this.$t("are_you_sure_delete"), this, () => {
        del("/helpdesk/agent", { uuid: this.meta.uuid })
          .then(() => {
            this.$emit("success");
            this.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      });
    },

    set_initial_state() {
      this.meta = {
        name: "",
        email: "",
        phone: "",
        department: "",
        specialties: [],
        working_hours_start: "08:00",
        working_hours_end: "17:00",
        is_active: true,
        can_receive_auto_assignments: true,
      };
      this.specialties_text = "";
      this.error = "";
    },
    set_user(value) {
      if (value) {
        this.meta.name = value.username;
        this.meta.email = value.email;
        this.meta.user_id = value.user_id;
      }
    },
  },
};
</script>
